var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.4412,
    height: 15.4412,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_303_257",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_303_257",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADI0lEQVR4nO3dv2sUQRQH8Is/8Ffhj0KDgjaC5N5coqRJZ6eN2vkviDaaTrDZQtS99+7QECzSWlpbCNYW4m+MIiIiIgoBk8DNC2nMyEZFozly583M7nrfD2ydmccw35uZ3UmlAgAAAAAAhXX7tFufHHUb8m7Hf+n6yNwONnpFjH0rRh2TXRBjHzRqegZF96RZa9XY2A9ZgWWVh0lfsGkN+/p7felabX4nk/3Yrsjys9jGLjLpuKu4gbzbXEpMenWtIsuKgutdrtrBvNtdOkz2XTeFluwhnamTPZF320sjGXVbuy6yWTG6b8mw25Z3Pwpv4qDb1Euh5fszjaDsgJC+7rXYjKBcW53sJQ+j2iEoO5in2ehLX8UWBGV7aXVhv5A+9zey7RIbe7M55rZ0Mn31leSA28xkJ7IieRvdRl81huyRvPtWSEz2GBv95HF0L0rNXkwqbl3efSscGW7tZtI7Hkd2Nnffqx/SvXn3rXBcxQ1kO3dCVn0GZaOqp/LuWyGlQy3yGZQ/fgZiRbkaBGVkjKCMRxCU8TgEZVwpgjKeBCvKuBhBGY8gKONxCMq4UgRlPAmCMi5GUMYjCMp4HIIyrhRBGU92cJsd4Po8o2SjT26Y1p6I3SgPIT2Znbx4Kzbpo6lRtzHvfhUSV+1g9paqx2Kfy7tPhQ5KJh1fPjXv/eT9ft796YugZNK5vPvRH79ISGfz7kdhOUwd5QtDMXo2QrP7++edkH2Iz/UCL1iE9DEWLL/BEjzSphIvf5XrbRTPZNNP6LaXhmCbNLwG2eN457qER1lctYdDtrtUUuw5h+UQeOEJAi9O4InRz77mYnxk9AcEXgQpAi8sh8ALTxB44TUQeGElWOGFlyLwIgQe6QUfx//Y0mxDEHjhNRB4YSHwIsju0RCjTz3uUyzhqp9VLxm0b3wGXh23PP6NjV72N5IV95a2fQ3L2PfY0gysWZ3fhTO8SO+8IfAiTR3/9N4b4aWVrjHpFAIvguaI7mOjXzo5w2NcPd9jsWs6tkaxp3FHtNeNJDv56x8r2K9s9JkYPY/PyQJJR2e340p5AAAAAACodOEbY5kCqd92LrkAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.a1b6bb3c2b3ac2912966a634a67c720f.svg";
export { ForwardRef as ReactComponent };